
import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Table,
  Button,
  Card,
  message,
  Tooltip,
} from "antd";
import {
  EditOutlined,
  SaveTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons";
import Service from "../../service";
import { useDispatch } from "react-redux";
import { hideAuthLoader, showAuthLoader } from "../../appRedux/actions/Auth";
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json"
const KarmaWeightage = () => {
  const [editId, setEditId] = useState("");
  const [flag, setFlag] = useState(false);
  const [editData, setEditData] = useState({});
  const dispatch = useDispatch()

  const [karmaSendingBalance, setkarmaSendingBalance] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 3, // Static total for demo
  });
  const [searchText, setSearchText] = useState("");
  const [seachEnabled, setSearchEnabled] = useState(false);

  const [paginationD, setPaginationD] = useState({
    current: 1,
    pageSize: 25,
  });
  const [designationList, setDesignationList] = useState([]);
  const [editedData, setEditedData] = useState({}); // Store updated values
  const [editdata, seteditedData] = useState({})

  console.log(editdata, 'editdata', editedData);
  const [editUpdateddata, seteditedUpdatedData] = useState({})


  console.log(editUpdateddata, 'editUpdateddata');

  const Search = Input.Search;

  const searchRef = useRef();

  let [editid, setEditid] = useState();
  const [edtitext, setEdittext] = useState({});

  // Static data for the table
  const [tableData, setTableData] = useState([
    // {
    //   id: 1,
    //   key: "CoLeader",
    //   karma_name: "CoLeader",
    //   amount: 1000,
    // },
    // {
    //   id: 2,
    //   key: "Junior & Mid Level",
    //   karma_name: "Junior & Mid Level",
    //   amount: 2000,
    // },
    // {
    //   id: 3,
    //   key: "TL",
    //   karma_name: "TL",
    //   amount: 3000,
    // },
    // {
    //   id: 4,
    //   key: "HR",
    //   karma_name: "HR",
    //   amount: 3000,
    // },
  ]);

  console.log(tableData, 'tableData');

  const onSearch = (value) => {
    setSearchText(value);

    setPagination({ ...pagination, current: 1 });
  };
  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };

  const handleEdit = (id) => {
    const updatedData = designationList.map((item) => {
      console.log(item.designationId, id, 'ttttttqt');

      if (item.designationId === id) {

        return { ...item, amount: editData.amount };
      }
      return item;
    });
    console.log(updatedData, 'updatedData');

    setDesignationList(updatedData);
    setFlag(true);
    setEditid(id);

  };


  const level = ['CoLeader', 'TL', 'HR', 'Junior & Mid Level']
  const columns = [
    {
      title: "Waffle Role",
      dataIndex: "karma_name",
      key: (value) => value.key,
      render: (value) => value,      // render: (text) => <span style={{ textTransform: "capitalize" }}>{text}</span>,
      //  render: (index) =>{
      //   console.log(['CoLeader','TL','HR','Junior & Mid Level'][index] ,index,'TTT');

      //    return ['CoLeader','TL','HR','Junior & Mid Level'][index] ?? "-"
      //  }
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text, record) => {
        return record.id === editId ? (
          <Input
            defaultValue={ text }
            onChange={ (e) => {
              setEditData({ ...editData, amount: e.target.value });
            } }
          />
        ) : (
          <span style={ { textTransform: "capitalize" } }>{ text }</span>
        );
      },
    },
    // ...(getResource(config.RESOURCES.WAFFLE_REWARD, ["update"])&&[

    // {
    //   title: "Actions",
    //   dataIndex: "action",
    //   render: (text, record) => (
    //     <div style={ { display: "flex", flexWrap: "wrap" } }>
    //       { flag && editId === record.id ? (
    //         <>
    //           <Button type="link" className="edit">
    //             <SaveTwoTone
    //               style={{ fontSize: "18px" }}
    //               onClick={() => {handleEdit(record.id);
    //                 // console.log(record.key,'record',record,editData);
    //                 getKarmaRewards(record?.key,editData?.amount)
    //               }}
    //             />
    //           </Button>
    //           <Button
    //             type="link"
    //             className="delete"
    //             onClick={ () => setEditId("") }
    //           >
    //             <CloseCircleTwoTone style={ { fontSize: "18px" } } />
    //           </Button>
    //         </>
    //       ) : (
    //         <Button type="link" className="edit">
    //           <EditOutlined
    //             style={ { fontSize: "18px" } }
    //             onClick={ () => {
    //               setEditId(record.id);
    //               setFlag(true);
    //             } }
    //           />
    //         </Button>
    //       ) }
    //     </div>
    //   ),
    // },])
    ...(getResource(config.RESOURCES.WAFFLE_WEIGHTAGE, ["update"])
      ? [
        {
          title: "Actions",
          dataIndex: "action",
          render: (text, record) => (
            <div style={ { display: "flex", flexWrap: "wrap" } }>
              { flag && editId === record.id ? (
                <>
                  <Tooltip title="Save">
                    <Button type="link" className="edit">
                      <SaveTwoTone
                        style={ { fontSize: "18px" } }
                        onClick={ () => {
                          handleEdit(record.id);
                          getKarmaRewards(record?.key, editData?.amount);
                        } }
                      />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Cancel">
                    <Button type="link" className="delete" onClick={ () => setEditId("") }>
                      <CloseCircleTwoTone style={ { fontSize: "18px" } } />
                    </Button>
                  </Tooltip>
                </>
              ) : (
                <Tooltip title="Edit">
                  <Button type="link" className="edit">
                    <EditOutlined
                      style={ { fontSize: "18px" } }
                      onClick={ () => {
                        setEditId(record.id);
                        setFlag(true);
                      } }
                    />
                  </Button>
                </Tooltip>
              ) }
            </div>
          ),
        },
      ]
      : []
    ),


  ];

  console.log(tableData, 'tableData');


  const handleTableChange = (page) => {
    setPagination({ ...pagination, ...page });
  };

  const getKarmaRewards = async (name, balance) => {
    try {
      let reqbody = {
        name, balance: Number(balance)
      }
      console.log(reqbody, 'reqbody');

      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.updateSendingBalance,
        body: reqbody
      });

      if (response.status) {
        dispatch(hideAuthLoader());
        // getEmployeesKarmaSendingBalanceByCategories()
        // console.log(response,'getKarmaRewards');

        // setKarmaistoryData(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };

  const getEmployeesKarmaSendingBalanceByCategories = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.getEmployeesKarmaSendingBalanceByCategories,
      });

      if (response.status) {
        dispatch(hideAuthLoader());

        const formattedData = response?.data?.data[0]?.categories.map((item, index) => ({
          id: index,
          key: item?.name,
          karma_name: item?.name,
          amount: item?.karma_sending_balance != null ? item?.karma_sending_balance : 0
        }));

        // console.log(formattedData);

        console.log(response.data.data, 'getEmployeesKarmaSendingBalanceByCategories', formattedData);
        setkarmaSendingBalance(response.data.data[0])
        setTableData(formattedData)
        // handleEdit()
        // setKarmaistoryData(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };

  const updateKarmaBalanceByDesignation = async (value) => {
    try {

      let rebBody = {
        designationId: value?.designationId,
        karma_balance: value?.waffle
      }

      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.updateKarmaBalanceByDesignation,
        body: rebBody
      });
      console.log(rebBody, 'rebBody', editUpdateddata, value);

      if (response.status) {
        dispatch(hideAuthLoader());
        getDesignationList()
        seteditedUpdatedData({})
        message.success("Amount updated successfully");

        // const formattedData = response?.data?.data?.categories.map((item,index) => ({
        //   id:index,
        //   key:item?.name,
        //   karma_name:item?.name,
        //   amount:item?.karma_sending_balance!=null?item?.karma_sending_balance:0
        // }));

        // console.log(formattedData);

        console.log(response.data, 'getEmployeesKarmaSendingBalanceByDesignation');
        // setkarmaSendingBalance(response.data.data)
        // setDesignationList(response.data.data);
        // setPaginationD({
        //   ...paginationD,
        //   total: response.data.totalRecords,
        //   // deactivetotal: response.data.metaData.totalFilteredPage,
        // });
        // setTableData(formattedData)
        // handleEdit()
        // setKarmaistoryData(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch rewards:", error);
    }
  };
  // useEffect(()=>{
  //   // getEmployeesKarmaSendingBalanceByCategories();
  //   getEmployeesKarmaSendingBalanceByDesignation()
  // },[])
  console.log(karmaSendingBalance, 'karmaSendingBalance');
  /////////////
  const handlechange = (e) => {
    let designation = e.target.value;
    console.log(e.target.value, "handle change value");

    setEdittext({ ...edtitext, designation: designation });
  };

  const handleChange = (value, record) => {
    setEditedData({ ...editedData, [record._id]: { ...record, waffle: value } });
  };

  const handleSave = (record) => {
    const updatedRecord = editedData[record.designationId] || record; // Use edited value or original
    console.log("Saved Data:", {
      designation_name: updatedRecord.designation_name,
      designationId: updatedRecord.designationId,
      waffle: updatedRecord.karma_balance ?? 0,
    });
    seteditedUpdatedData({
      designation_name: updatedRecord.designation_name,
      designationId: updatedRecord.designationId,
      waffle: updatedRecord.karma_balance ?? 0,
    })
    seteditedData(editedData)
    handleEdit(updatedRecord); // Call your edit function
    setFlag(false);
    setEditid("");
    setEditedData({}); // Reset edited data
    updateKarmaBalanceByDesignation({
      designation_name: updatedRecord.designation_name,
      designationId: updatedRecord.designationId,
      waffle: updatedRecord.karma_sending_balance ?? 0,
    })
  };
  const columnsDesignation = [
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      render: (text, record) => (
        <span style={ { textTransform: "capitalize" } }>
          { record?.designation_name }
        </span>
      ),
    },
    {
      title: "Waffle",
      dataIndex: "waffle",
      key: "waffle",
      render: (text, record) => {
        const waffleAmount = editedData[record.designationId]?.karma_sending_balance ?? record?.karma_sending_balance ?? 0;
        console.log(record.designationId == editid, 'record.designationId == editid',
          record.designationId, editid
        );

        return record.designationId == editid?.designationId ? (
          <Input
            value={ waffleAmount }
            onChange={ (e) =>
              setEditedData({
                ...editedData,
                [record.designationId]: { ...record, karma_sending_balance: e.target.value },
              })
            }
          />
        ) : (
          <span>{ waffleAmount }</span>
        );
      },
    },

    ...(getResource(config.RESOURCES.WAFFLE_WEIGHTAGE, ["update"])
      ? [{
        title: "Actions",
        dataIndex: "action",
        render: (text, record) => (
          <div style={ { display: "flex", flexWrap: "wrap" } }>
            { editid?.designationId === record.designationId ? (
              <>
                <Tooltip title="Save">
                  <Button type="link" className="edit">
                    <SaveTwoTone
                      style={ { fontSize: "18px" } }
                      onClick={ () => handleSave(record) }
                    />
                  </Button>
                </Tooltip>
                <Tooltip title="Cancel">
                  <Button type="link" className="delete" onClick={ () => setEditid("") }>
                    <CloseCircleTwoTone style={ { fontSize: "18px" } } />
                  </Button>
                </Tooltip>
              </>
            ) : (
              <Tooltip title="Edit">
                <Button type="link" className="edit">
                  <EditOutlined
                    style={ { fontSize: "18px" } }
                    onClick={ () => handleEdit(record) }
                  />
                </Button>
              </Tooltip>
            ) }
          </div>
        ),
      }]
      : []),

    ,
  ];



  const getDesignationList = async (values) => {
    try {
      dispatch(showAuthLoader());

      const reqBody = {
        pageNum: paginationD.current,
        pageLimit: paginationD.pageSize,
      };

      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        // api_url: Service.empDesignationList,
        api_url: Service.getEmployeesKarmaSendingBalanceByDesignation,


        body: reqBody,
      });

      if (response.data && response.data.data) {
        setDesignationList(response.data.data);
        setPaginationD({
          ...paginationD,
          total: response.data.metaData.totalRecords,
          deactivetotal: response.data.metaData.totalFilteredPage,
        });
        setEditid("")
        dispatch(hideAuthLoader());
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  // useEffect(()=>{getDesignationList()}, [searchText, paginationD.current, paginationD.pageSize])
  useEffect(() => {
    getDesignationList();
  }, [paginationD.current, paginationD.pageSize, searchText]);

  const handleTableChangeesignt = (page, filters, sorter) => {
    setPaginationD({ ...paginationD, ...page });
  };

  const getFooterDetails = () => {
    return (
      <label>
        Total Records Count is { paginationD.total > 0 ? paginationD.total : 0 }
      </label>
    );
  };
  return (
    <>
      {/* <Card title="Waffle Weightage" icon={ <WeightageIcon /> } className="employee-card">
        <Table
          columns={ columns }
          dataSource={ tableData }
          footer={ false }
          onChange={ handleTableChange }
          pagination={ false }
        />
      </Card> */}
      <Card className="employee-card">

        <div className=" inout-header text-left">
          <h2> Waffle Weightage</h2>

        </div>
        <Card className="main-content-wrapper" >

          <div className="search-wrapper">
            <Search
              ref={ searchRef }
              placeholder="Search..."
              onSearch={ onSearch }
              onKeyUp={ resetSearchFilter }
              style={ { width: 200 } }
              className="mr2"
            />
          </div>
          <div className="main-table-wrapper">

            <Table
              columns={ columnsDesignation }
              pagination={ {
                showSizeChanger: true,
                ...paginationD,
              } }
              footer={ getFooterDetails }
              onChange={ handleTableChangeesignt }
              dataSource={ designationList }
            />
          </div>
        </Card>
      </Card>
    </>
  );
};

export default KarmaWeightage;
